export default __webpack_public_path__ + "static/media/detail3.4dcc4161.avif";